import { render } from "./editPatient.vue?vue&type=template&id=466e85e6&scoped=true"
import script from "./editPatient.vue?vue&type=script&lang=js"
export * from "./editPatient.vue?vue&type=script&lang=js"

import "./editPatient.vue?vue&type=style&index=0&id=466e85e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466e85e6"]])

export default __exports__